import { render, staticRenderFns } from "./SecurityImages.vue?vue&type=template&id=667c48cc"
import script from "./SecurityImages.vue?vue&type=script&lang=js"
export * from "./SecurityImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports